module.exports = __webpack_public_path__ + "img/user-outline.svg";